module.exports = __webpack_public_path__ + "c1504ed37953bb09c06df06dfd360363.png";